<template>
<span class="kwd" v-if="disv == 'w' && value> 10000">
    <small v-if="start">{{start}}</small> {{value | formatW }}<small>{{$t('tenThousand')}}</small>
</span>
 <span class="kwd" v-else-if="disv == 'k' && value> 1000"><small v-if="start">{{start}}</small>{{value | formatK }} <small>K</small>
</span>
<span class="kwd" v-else>
       <small v-if="start">{{start}}</small> {{value}}
  </span>
</template>
<script>
export default {
  data() {
    return {
      disv: "k"
    };
  },
  props: {
    value: {
      default: ""
    },
    dis: {
      default: "k"
    },
    start: {
      default: "￥"
    }
  },
  mounted() {
    if (this.dis) {
      this.disv = this.dis;
    }

  },
  filters: {
    formatW(value) {
      return (value / 10000).toFixed(2);
    },
    formatK(value) {
      return (value / 1000).toFixed(2);
    }
  }
};
</script>
<style lang='less' scoped>
.kwd {
  small {
    font-size: 0.32rem;
  }
}
</style>



// WEBPACK FOOTER //
// formatKW.vue?34e5c3b6